"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME = void 0;
exports.NAME = {
    UPDATE_NAME: "UPDATE-NAME",
    RISK_LEVEL: "RISK-LEVEL",
    LEGAL_NAME: "LEGAL-NAME",
    MAJOR_NAME: "MAJOR-NAME",
    MINOR_NAME: "MINOR-NAME",
    UPDATE_OCCUPATION: "UPDATE-OCCUPATION",
    SET_TCPA: "SET-TCPA",
};
